/* Carrusel de la portada — el JS de `sections/mibi-carrusel.liquid`.

   VIVE EN UN ARCHIVO APARTE POR DOS RAZONES, y la segunda es la que decidió.

   1. Se cachea. Inline se vuelve a descargar con cada HTML; como asset lo pide una vez
      y vale para toda la sesión de navegación.
   2. La sección entera pesaba 17,5 KB, y una subida por MCP ya se truncó a mitad de
      payload a los 18 KB en este mismo proyecto. Un archivo Liquid truncado no avisa:
      se guarda, el tema queda con una etiqueta sin cerrar y el fallo aparece al
      renderizar. Partirlo en dos deja las dos mitades muy por debajo del límite.

   Va con `defer`: el carrusel funciona sin JavaScript —el gesto es `scroll-snap` de
   CSS— así que nada de esto es crítico para pintar la primera pantalla. */
(function () {
  document.querySelectorAll('[data-slider]').forEach(function (s) {
    var pista = s.querySelector('[data-slider-pista]');
    if (!pista) return;
    var slides = Array.prototype.slice.call(pista.children);
    var puntos = Array.prototype.slice.call(s.querySelectorAll('[data-slider-punto]'));
    if (slides.length < 2) return;

    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var quiere = s.getAttribute('data-autoplay') === 'true' && !reduce;
    var ms = (parseInt(s.getAttribute('data-segundos'), 10) || 6) * 1000;
    var i = 0, timer = null, detenido = false, yendo = false, boton = null;

    var SVG_PAUSA = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><rect x="6.5" y="5" width="4" height="14" rx="1"/><rect x="13.5" y="5" width="4" height="14" rx="1"/></svg>';
    var SVG_PLAY  = '<svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true"><path d="M8 5.2 19 12 8 18.8z"/></svg>';

    function marcar() {
      puntos.forEach(function (p, k) {
        p.classList.toggle('is-on', k === i);
        p.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
    }
    function ir(n) {
      i = (n + slides.length) % slides.length;
      yendo = true;
      pista.scrollTo({ left: pista.clientWidth * i, behavior: reduce ? 'auto' : 'smooth' });
      marcar();
      setTimeout(function () { yendo = false; }, 450);
    }
    function arrancar() {
      if (!quiere || detenido || timer) return;
      timer = setInterval(function () { ir(i + 1); }, ms);
    }
    function parar() { if (timer) { clearInterval(timer); timer = null; } }
    function rendirse() {
      /* El usuario ha tomado el mando. El avance no vuelve solo: recuperarlo cuando
         alguien acaba de deslizar a mano le arrebata la diapositiva que estaba mirando.
         El botón pasa a «reproducir» para que el control siga significando algo. */
      detenido = true; parar();
      if (boton) {
        boton.setAttribute('aria-pressed', 'true');
        boton.setAttribute('aria-label', 'Reanudar el carrusel');
        boton.innerHTML = SVG_PLAY;
      }
    }

    var t;
    pista.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        /* Cada diapositiva ocupa el 100 % del carril, así que el índice es una división.
           Se lee del scroll REAL en vez de llevar la cuenta aparte, y por eso los puntos
           siguen siendo correctos cuando el movimiento vino de un dedo. */
        var n = Math.round(pista.scrollLeft / pista.clientWidth);
        if (n !== i) { i = n; marcar(); }
      }, 90);
    }, { passive: true });

    ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) {
      pista.addEventListener(ev, function () { if (!yendo) rendirse(); }, { passive: true });
    });

    s.querySelectorAll('[data-slider-ir]').forEach(function (b) {
      b.addEventListener('click', function () {
        ir(i + parseInt(b.getAttribute('data-slider-ir'), 10));
        rendirse();
      });
    });
    puntos.forEach(function (p) {
      p.addEventListener('click', function () {
        ir(parseInt(p.getAttribute('data-slider-punto'), 10));
        rendirse();
      });
    });

    if (quiere) {
      var slot = s.querySelector('[data-slider-pausa-slot]');
      if (slot) {
        boton = document.createElement('button');
        boton.type = 'button';
        boton.className = 'mibi-car__pausa';
        boton.setAttribute('aria-pressed', 'false');
        boton.setAttribute('aria-label', 'Pausar el carrusel');
        boton.innerHTML = SVG_PAUSA;
        boton.addEventListener('click', function () {
          if (detenido) {
            detenido = false;
            boton.setAttribute('aria-pressed', 'false');
            boton.setAttribute('aria-label', 'Pausar el carrusel');
            boton.innerHTML = SVG_PAUSA;
            arrancar();
          } else { rendirse(); }
        });
        slot.appendChild(boton);
      }
      s.addEventListener('mouseenter', parar);
      s.addEventListener('mouseleave', arrancar);
      s.addEventListener('focusin', parar);
      s.addEventListener('focusout', arrancar);
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) parar(); else arrancar();
      });
      arrancar();
    }
  });
})();
